import http from 'plugins/axios';

function query(params = {}) {
  return Object.keys(params)
    .filter((key) => params[key] !== undefined && params[key] !== null && params[key] !== '')
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');
}

export default {
  enums() {
    return http.get({ url: '/ta/admin/tenant/vip/recharge-trial-card/approval/enums' });
  },
  page(params) {
    return http.get({ url: `/ta/admin/tenant/vip/recharge-trial-card/approval/page?${query(params)}` });
  },
  detail(id) {
    return http.get({ url: `/ta/admin/tenant/vip/recharge-trial-card/approval/detail?id=${encodeURIComponent(id)}` });
  },
  review(data) {
    return http.post({ url: '/ta/admin/tenant/vip/recharge-trial-card/approval/review', data });
  },
  couponOptions() {
    return http.get({ url: '/ta/admin/tenant/welfare/coupon/options?couponType=TASK_VIP' });
  },
  config() {
    return http.get({ url: '/ta/admin/tenant/vip/recharge-trial-card/approval/config' });
  },
  saveConfig(data) {
    return http.post({ url: '/ta/admin/tenant/vip/recharge-trial-card/approval/config', data });
  },
};
